module.exports = __webpack_public_path__ + "static/media/icon_dichengben_wap.77450354.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_temperature/icon_dichengben_wap.svg
// module id = 499
// module chunks = 0